import React, {useEffect, useState} from 'react';

import MultiStateButton from '../../common/genericComponents/redesign/multiStateButton/multiStateButton';
import PillComponent from '../../common/genericComponents/pillComponent/pillComponent';
import ShimmerComponent from '../../common/shimmerComponent/shimmerComponent';

import c2CMoneyTransactionRestService from '../../../services/restServices/c2cMoneyTransactionEventService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './c2cMoneyTransactionChatComponent.css';

const C2cMoneyTransactionChatComponent = ({align = 'left', chatMessageDto}) => {
  const [c2cMoneyTransactionEventDto, setC2cMoneyTransactionEventDto] =
    useState({});

  useEffect(() => {
    fetchC2cMoneyTransaction(chatMessageDto);
  }, []);

  const fetchC2cMoneyTransaction = async (chatMessageDto) => {
    const metaData = JSON.parse(chatMessageDto.metaData);
    const c2cMoneyTransactionEventId = metaData.c2cMoneyTransactionEventId;
    const response =
      await c2CMoneyTransactionRestService.getC2cMoneyTransactionEventById(
        c2cMoneyTransactionEventId,
      );
    if (response.success === true) {
      setC2cMoneyTransactionEventDto(response.data);
    }
  };

  const handleOpenReceipt = () => {
    window.open(c2cMoneyTransactionEventDto.receiptUrl, '_blank');
  };

  return (
    <div
      className={`et-c2cmt-chat-container ${align === 'right' ? 'et-c2cmt-chat-container-right-align' : ''}`}>
      <div className="et-c2cmtc-title-wrap">
        <div className="et-c2cmtc-payment-request-title">{`Payment request `}</div>
        {c2cMoneyTransactionEventDto.eventType ? (
          <PillComponent
            pillTxt={
              c2cMoneyTransactionEventDto.eventType ===
              VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE.INIT
                ? c2cMoneyTransactionEventDto.paymentFlowType ===
                  VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE
                    .DURING_CHAT
                  ? 'Sent'
                  : 'Initiated'
                : c2cMoneyTransactionEventDto.eventType ===
                    VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE.PAID
                  ? 'Paid'
                  : c2cMoneyTransactionEventDto.eventType ===
                      VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE
                        .REFUNDED
                    ? 'Refunded'
                    : c2cMoneyTransactionEventDto.eventType ===
                        VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE
                          .CANCEL_REFUND
                      ? 'Refund cancelled'
                      : c2cMoneyTransactionEventDto.eventType ===
                          VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE
                            .ERROR
                        ? 'Error'
                        : ''
            }
            pillType={
              c2cMoneyTransactionEventDto.eventType ===
              VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE.INIT
                ? VIDABOO_CONSTANTS.PILL_TYPES.IN_ACTIVE
                : c2cMoneyTransactionEventDto.eventType ===
                    VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE.PAID
                  ? VIDABOO_CONSTANTS.PILL_TYPES.ACTIVE
                  : c2cMoneyTransactionEventDto.eventType ===
                      VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE
                        .REFUNDED
                    ? VIDABOO_CONSTANTS.PILL_TYPES.DELETE
                    : c2cMoneyTransactionEventDto.eventType ===
                        VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE
                          .CANCEL_REFUND
                      ? VIDABOO_CONSTANTS.PILL_TYPES.ACTIVE
                      : c2cMoneyTransactionEventDto.eventType ===
                          VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE
                            .ERROR
                        ? VIDABOO_CONSTANTS.PILL_TYPES.DELETE
                        : null
            }
          />
        ) : (
          <div className="et-c2cmtc-event-type-shimmer">
            <ShimmerComponent />
          </div>
        )}
      </div>
      <div className="et-c2cmtc-body-wrap">
        <div className="et-c2cmtc-body-item-wrap">
          <div className="et-c2cmtc-item-title">Amount:</div>
          {c2cMoneyTransactionEventDto.totalAmount ? (
            <div className="et-c2cmtc-item-value">
              {c2cMoneyTransactionEventDto.totalAmount / 100}{' '}
              {c2cMoneyTransactionEventDto.eventType !==
                VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_EVENT_TYPE.INIT &&
                'Net'}
            </div>
          ) : (
            <div className="et-c2cmtc-amount-shimmer">
              <ShimmerComponent />
            </div>
          )}
        </div>
        <div className="et-c2cmtc-body-item-wrap">
          <div className="et-c2cmtc-item-title">Currency: </div>
          {c2cMoneyTransactionEventDto.currency ? (
            <div className="et-c2cmtc-item-value">
              {c2cMoneyTransactionEventDto.currency}
            </div>
          ) : (
            <div className="et-c2cmtc-currency-shimmer">
              <ShimmerComponent />
            </div>
          )}
        </div>
      </div>
      {c2cMoneyTransactionEventDto.receiptUrl && (
        <div className="et-c2cmtc-bottom-btns-wrap">
          <div className="et-c2cmtc-bottom-btn-wrap">
            <MultiStateButton btnTxt="Receipt" onClick={handleOpenReceipt} />
          </div>
        </div>
      )}
    </div>
  );
};

export default C2cMoneyTransactionChatComponent;
